import type { FetchFunction } from '#layers/base/public';
import type { SystemMonospaceFile as FileType } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { createFileHooks } from '~/rstore/utils/collections/files';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const FILE_DATETIME_FIELDS = ['createdAt', 'updatedAt'] as const;

export function createSystemFile(systemFetch: FetchFunction) {
	return withItemType<FileType>().defineCollection({
		name: 'SystemMonospaceFile',
		scopeId: MONOSPACE_SCOPE_ID,
		fields: defineSystemDateTimeFields(FILE_DATETIME_FIELDS),
		meta: {
			defaultFields: [
				'id',
				'fileName',
				'fileSize',
				'mediaType',
				'createdAt',
				'updatedAt',
			],
			endpoint: 'system/files',
			primitiveFieldTypes: defineSystemDateTimeFieldTypes(FILE_DATETIME_FIELDS),
		},
		hooks: createFileHooks({ fetch: systemFetch, assetsEndpoint: 'system/assets' }),
	});
}
